import { Injectable, NgZone } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: 'root'
  })

export class NotificationService{
    constructor(protected notificationService: ToastrService, private zone: NgZone
    ){}

    warning(title?: string, message?: string){
        // this.notificationService.warning(message, title);
        this.ZoneRun(title, message, "warning");
    }

    info(title?: string, message?: string){
        // this.notificationService.info(message, title);
        this.ZoneRun(title, message, "info");
    }
    
    success(title?: string, message?: string){
        // this.notificationService.success(message, title);
        this.ZoneRun(title, message, "success");
    }

    error(title?: string, message?: string){
        // this.notificationService.error(message, title);
        this.ZoneRun(title, message, "error");
    }

    private ZoneRun(title: string, message: string, vrsta: string ) {
        switch(vrsta){
            case "warning": return this.zone.run(() => this.notificationService.warning(message, title));
            case "info": return this.zone.run(() => this.notificationService.info(message, title));
            case "success": return this.zone.run(() => this.notificationService.success(message, title));
            case "error": return this.zone.run(() => this.notificationService.error(message, title));
        }


        // this.zone.run(() => this.notificationService.error(message, title));
    }
}

